<!-- //
上传文件
@auth xuyd
@date 2022-09-10
//-->
<template>
  <el-upload
      class="refUpload"
      drag
      :multiple="multiple"
      :accept="accept"
      action="#"
      :auto-upload="false"
      :limit="limit"
      :on-exceed="handleLimit"
      :file-list="form.fileList"
      :on-change="handleFileChange"
      :on-remove="handleFileRemove"
  >
    <i class="el-icon-upload"></i>
    <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
    <div class="el-upload__tip" slot="tip">
      <el-tag v-if="accept">{{ `请上传${accept}文件` }}</el-tag>
      <el-tag v-if="size" class="ml10">{{ `不超过${size}MB` }}</el-tag>
    </div>
  </el-upload>
</template>
<script>

export default {
  name: 'Upload',
  data() {
    return {}
  },

  props: {
    form: {
      type: Object,
      default: () => {
        return {fileList: []}
      },
    },
    accept: {
      type: String, // 50mb
      default: '',
    },
    multiple: {
      type: Boolean, // 多选
      default: false,
    },
    limit: {
      type: Number,
      default: 1,
    },
    size: {
      type: Number, // 50mb
      default: 50,
    }
  },

  methods: {
    handleLimit(files, fileList) {
      this.$modal.msgError(`超过了限制，每次只能上传${this.limit}个文件。`)
    },
    checkFile(file) {
      // console.log("-------handleCheck-------->", file)
      if (this.accept) {
        const arr = file.name.split('.')
        let type = arr[arr.length - 1]
        let acceptArr = this.accept.split(',')
        if (!acceptArr.includes("." + type)) {
          this.$modal.msgError(`只能上传${this.accept}文件!`);
          return false;
        }
      }
      if (file.size / 1024 / 1024 > this.size) {
        this.$modal.msgError(`文件大小不能超过${this.size}MB`);
        return false;
      }
      return true;
    },

    /**
     * 一次上传多个文件，每个文件都调用一次chagne
     * @param file
     * @param fileList
     */
    handleFileChange(file, fileList) {
      // console.log("-------handleFileChange-------->", file, fileList, this.fileList)
      let resultFileList = [];
      for (let i in fileList) {
        if (this.checkFile(fileList[i])) {
          resultFileList.push(fileList[i])
        }
      }
      if (resultFileList.length <= 0) {// 两方都clear
        this.form.fileList = [];
        this.$refs.refUpload.clearFiles();
      } else {
        this.form.fileList = resultFileList;
      }
    },

    handleFileRemove(file, fileList) {
      // console.log("-------handleFileRemove-------->", file, fileList, this.fileList)
      this.form.fileList = fileList;
    },
  },
}
</script>

<style lang="less" scoped>
//.upload {
//  width: 100%;
//
//  .el-upload {
//    width: 100%;
//
//    .el-upload-dragger {
//      width: 100%;
//    }
//  }
//}
</style>


